import {Toast} from 'vant';
import './index.styl'
window.$toast = Toast
Toast.setDefaultOptions({ duration: 3000,position:'bottom' })
export default Toast;
//使用方法　https://www.youzanyun.com/zanui/vant#/zh-CN/component/toast
